import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import AppMenu from './application-menu';
import UserMenu from './user-menu';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import FeatureUtils from 'utils/features';

import Reactor from 'data/reactor';
import RuntimeGetters from 'data/app-runtime/getters';
import { findShowMethodForModal } from 'utils/runtime';
import { sharedModalReferences } from 'resources/common-values';
import Actions from 'data/actions';

export default CreateReactClass({
    displayName: 'NavigationBar',

    propTypes: {
        menuItems: PropTypes.instanceOf(Immutable.List).isRequired,
        route: PropTypes.string,
        username: PropTypes.string,
    },

    companyLogoClick(e) {
        Analytics.recordButtonClick(CommonValues.SectionIDs.header, 'nwea-brand-img');

        //Show the save changes prompt if there is unsaved data
        if (Reactor.evaluate(RuntimeGetters.unsavedData)) {
            const showSaveDataPrompt = findShowMethodForModal(
                Reactor.evaluate(RuntimeGetters.modalReferences),
                sharedModalReferences.saveDataPrompt
            );
            //Note this matches the rendered html below
            const linkTarget = e.nativeEvent.target.parentElement.href;
            e.preventDefault();
            showSaveDataPrompt()
                .then(() => {
                    Actions.runtime.setUnsavedData(false);
                    //now follow the link as supplied by the original event
                    window.location.href = linkTarget;
                })
                .catch(() => {
                    /* do nothing */
                });
        }
    },

    render() {
        const extension = FeatureUtils.isIE() ? '.png' : '.svg';
        const companyLogo = require(`styles/icons/mapJigsaw${extension}`);
        const title =
            this.props.route && this.props.route.includes('family-report') ? 'Family Report' : 'Student Profile';

        return (
            <div id="navigation-bar">
                <AppMenu menuItems={this.props.menuItems} key="standard-nav-links" />
                <a href="/report/home/map" key="nwea-logo">
                    <img id="company-logo" key="company-logo" src={companyLogo} onClick={this.companyLogoClick} />
                </a>
                <div className="title" key="title">
                    <span key="nwea-reports-title">{title}</span>
                </div>
                <UserMenu username={this.props.username} route={this.props.route} key="user-name" />
            </div>
        );
    },
});
